import React from 'react';
import BubbleButton from './BubbleButton';

interface BubbleDrawerHeaderPropsBase {
  title: string;
  subtitle?: string;
  onClose?: () => void;
}

type BubbleDrawerHeaderProps = BubbleDrawerHeaderPropsBase & React.HTMLProps<HTMLDivElement>;

function BubbleDrawerHeader(props: BubbleDrawerHeaderProps) {
  const { title, subtitle, onClose, className, ...rest } = props;

  const classes = ['p-8 pb-0'];

  if (className) classes.push(className);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className="flex items-start mb-5">
        <div>
          <h1 className="text-lg text-slate-dark font-semibold">{title}</h1>
          {subtitle && <h2 className="text-2xl text-navy">{subtitle}</h2>}
        </div>
        {onClose && (
          <BubbleButton
            onClick={onClose}
            className="ml-auto"
            variant="navy"
            inverse
            icon="xmark-large"
            iconSize="xl"
          />
        )}
      </div>
      {rest.children}
    </div>
  );
}

export default BubbleDrawerHeader;
